import HttpClient from '@/util/http/HttpClient';
import ProductOrder from '@/repositories/data/webshop/ProductOrder';
import BaseCrudRepository from '@/repositories/BaseCrudRepository';

export default class ProductOrderRepository extends BaseCrudRepository<
    { [key: string]: any[] },
    ProductOrder,
    ProductOrder
> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/product-order/');
    }
}
